import { DwQueryFilterGroup } from '@devwareapps/devware-cap';

export enum ReportFilterPresetOwnershipType {
  System = 1,
  FlightSchool = 2,
  User = 3
}

export type ReportDatePeriodMode =
  | 'rollingDays'
  | 'currentMonth'
  | 'previousMonth'
  | 'currentQuarter'
  | 'previousQuarter'
  | 'currentYear'
  | 'previousYear'
  | 'exactRange';

export interface ReportDatePeriodState {
  mode: ReportDatePeriodMode;
  days?: number;
  start?: string;
  end?: string;
}

export interface ReportSavedCustomFilterState<TValue = any> {
  filterKey: string;
  filterTypeKey: string;
  attribute: string;
  value: TValue;
}

export interface ReportSavedFilterState {
  schemaVersion: 1;
  filters: ReportSavedCustomFilterState[];
}

/** In-memory user choices owned by the open group page, keyed by compatible filter schema. */
export interface ReportGroupFilterSession {
  [key: string]: { filterGroup: DwQueryFilterGroup; filterState: ReportSavedFilterState };
}

export interface ReportFilterPresetRecord {
  ReportFilterPresetId?: number;
  DashboardKey: string;
  PresetName: string;
  PresetDescription?: string;
  ReportFilterPresetOwnershipTypeId: ReportFilterPresetOwnershipType;
  OwnerUserId?: number;
  FlightSchoolOrganizationId?: number;
  FilterGroupJSON: string;
  FilterStateJSON?: string;
  SortOrder: number;
  IsActive: boolean;
}

export interface ReportFilterPreferenceRecord {
  ReportFilterPreferenceId?: number;
  UserId: number;
  DashboardKey: string;
  DefaultReportFilterPresetId?: number;
}

export interface ResolvedReportFilterPreset {
  record: ReportFilterPresetRecord;
  filterGroup: DwQueryFilterGroup;
  filterState: ReportSavedFilterState;
}

export interface ReportFilterPresetManageItem {
  presetId?: number;
  name: string;
  ownershipType?: ReportFilterPresetOwnershipType;
  sortOrder: number;
  isDashboardDefault?: boolean;
  isDefault?: boolean;
  canManage?: boolean;
  remove?: boolean;
}

export interface ReportFilterPresetManageResult {
  orders: Array<{ presetId: number; sortOrder: number }>;
  removedPresetIds: number[];
  defaultPresetId?: number;
  defaultChanged: boolean;
}
